
import {Component} from 'vue-property-decorator';
import LastSync from '@/components/LastSync.vue';
import BaseReport from '../../../BaseReport.vue';
import moment from 'moment';
import BICustomerRenewalDashboard from '@/components/reports-v3/components/codedWidgets/custom/_internal/BICustomerRenewalDashboard.vue';

@Component({
    components: {
        LastSync,
        BICustomerRenewalDashboard,
    },
})
export default class DataEmpCustom1 extends BaseReport {
    public selectedDay: number = moment().endOf('day').valueOf();

    public get selectedAsOfDate() {
        return moment(this.selectedDay).endOf('day').valueOf();
    }
}
